import axios from '@/axios.js'

const customerId = localStorage.getItem("customer_id")

export default {
  getTemplates ({ commit }, { page,orientation_type,size }) {
    return axios.post(`/certificate/template/list/${customerId}?page=${page}`, {
      type: 'string',
      orientation_type : orientation_type,
      size: size
    })
      .then(({ data }) => {
        commit('GET_CETIFICATE_TEMPLATE_LIST', data)
      })
  },

  getDynamicTexts ({ commit }, payload) {
    axios.post('/certificate/dynamic_field_list', {
      type: 'string'
    })
      .then(({ data }) => {
        commit('GET_CETIFICATE_DYNAMIC_TEXTS', data)
      })
  },

  getStudents ({ commit }) {
    axios.post(`/classes/schedules/students/${customerId}`, {
      type: 'string'
    })
      .then(({ data }) => {
        commit('GET_STUDENTS_LIST', data)
      })
  },

  getTeachers ({ commit }) {
    axios.post(`/classes/schedules/teachers/${customerId}`, {
      type: 'string'
    })
      .then(({ data }) => {
        commit('GET_TEACHERS_LIST', data)
      })
  },

  getClasses ({ commit }, { page, limit }) {
    return axios.post(`/classes/list/${customerId}?page=${page}&limit=${limit}`, { is_archived: 1 })
      .then(({ data }) => {
        commit('GET_CLASS_LIST', data)
        return Promise.resolve(data)
      })
  },

  getClassDetail ({ commit }, classId) {
    axios.get(`/classes/show/${classId}/${customerId}`)
      .then(({ data }) => {
        commit('GET_CLASS_DETAIL', data)
      })
  },

  getCourseList ({ commit }, { page, limit }) {
    return axios.post(`/V1/course/list/${customerId}?page=${page}`, { limit })
      .then(({ data }) => {
        commit('GET_COURSE_LIST', data)
        return Promise.resolve(data)
      })
  }
}

